import { useTranslation } from 'react-i18next';

import Loading from '$app-web/components/loading';

interface Props {
    callParticipantName?: string;
    loading: boolean;
    mode: 'connecting' | 'screen-share';
}

const LoadingOverlay = (props: Props) => {
    const { callParticipantName, loading, mode } = props;

    const { t } = useTranslation();

    return (
        <Loading
            backdropVariant="dark"
            loading={loading}
            variant="parent-overlay"
            icon={mode === 'screen-share' ? ['far', 'arrow-square-up'] : null}
            loadingText={mode === 'screen-share' ? `${callParticipantName} ${t('rdash:is_presenting')}` : t('pdash:connecting')}
            overCallScreen
        />
    );
};

export default LoadingOverlay;
